<template>
    <div id="producthistorypage">
        <ui5-button @click="goToProductPage(idParam)">{{ trans('pages.product_history.cancel') }}</ui5-button>
        <div>
            <div
                class="prevproductstate"
                v-for="(state, index) in states"
                :key="'state.' + index">
                <div class="productstatedate">
                    {{ state.date }} -- {{ state.employeeName }}
                </div>
                <p>{{ state.productId }} - {{ state.status }}</p>
                <p v-if="state.statuserror != null && state.statuserror != ''">
                    {{ state.statuserror }}
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import productApi from '../api/product';
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), NavigationFunctionsMixin, localization],
    data() {
        return {
            states: [],
        };
    },
    methods: {
        load() {
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.product_history.page_title', { productId: this.idParam }),
                { root: true }
            );
            this.populatePreviousStates();
        },
        populatePreviousStates() {
            productApi.history(this.idParam).then((response) => {
                this.states = response.data.data;
            });
        },
    },
};
</script>
